import angular from 'angular';

import { SecurityRoutingModule } from './security-routing.module';
import { RoleListComponent } from './roles/role-list.component';
import { EditRoleComponent } from './roles/edit-role.component';
import { CreateClaimModalComponent } from './roles/create-claim-modal.component';
import { EditClaimComponent } from './roles/edit-claim.component';
import { EditClaimPermissionModalComponent } from './roles/edit-claim-permission-modal.component';
import { PermissionListComponent } from './roles/permission-list.component';
import { SecurityNavComponent } from './security-nav.component';
import { IdentityClaimsListComponent } from './identity-claims-list.component';
import { ClaimValueSelectComponent } from './roles/claim-value-select.component';
import { ClaimTypesSelectComponent } from './roles/claim-types-select.component';


export const SecurityModule = angular
    .module("apex.mainApp.security", [
        SecurityRoutingModule
    ])
    .component("apexRoleList", RoleListComponent)
    .component("apexEditRole", EditRoleComponent)
    .component("apexCreateClaimModal", CreateClaimModalComponent)
    .component("apexIdentityClaimsList", IdentityClaimsListComponent)
    .component("apexEditClaim", EditClaimComponent)
    .component("apexEditClaimPermissionModal", EditClaimPermissionModalComponent)
    .component("apexPermissionList", PermissionListComponent)
    .component("apexSecurityNav", SecurityNavComponent)
    .component("apexClaimValueSelect", ClaimValueSelectComponent)
    .component("apexClaimTypesSelect", ClaimTypesSelectComponent)
    .name
